import deepEqual from 'lodash/isEqual';
import { useRef, useMemo } from 'react';

// from https://github.com/kentcdodds/use-deep-compare-effect/blob/ec3c204ae3a29be7db8e30fc7ca29dd38d1c9441/src/index.ts

/**
 * @param value the value to be memoized (usually a dependency list)
 * @returns a memoized version of the value as long as it remains deeply equal
 */
export function useDeepCompareMemoize<T>(value: T) {
    const ref = useRef<T>(value);
    const signalRef = useRef<number>(0);

    if (!deepEqual(value, ref.current)) {
        ref.current = value;
        signalRef.current += 1;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => ref.current, [signalRef.current]);
}
